import { m } from 'framer-motion';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Slider from 'react-slick';
// @mui
import { styled } from '@mui/material/styles';
import { Slide } from 'react-slideshow-image';
import { Button, Box, Link, Container, Typography, Stack } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import TextIconLabel from '../../components/TextIconLabel';
import { MotionContainer, varFade } from '../../components/animate';
import backgroundPic from '../../assets/background.png';
import TextAnimation from './TextAnimation';

// ----------------------------------------------------------------------

const RootStyle = styled(m.div)(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#F4F4F4',
  [theme.breakpoints.up('md')]: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
  },
}));

const ContentStyle = styled((props) => <Stack spacing={5} {...props} />)(({ theme }) => ({
  zIndex: 10,
  maxWidth: 850,
  margin: 'auto',
  textAlign: 'center',
  position: 'relative',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(15),
  [theme.breakpoints.up('md')]: {
    textAlign: 'center',
  },
}));

const HeroOverlayStyle = styled(m.img)({
  zIndex: 9,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

const HeroImgStyle = styled(m.img)(({ theme }) => ({
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 8,
  width: '100%',
  margin: 'auto',
  position: 'absolute',
  [theme.breakpoints.up('lg')]: {
    right: '8%',
    width: 'auto',
    height: '48vh',
  },
}));

function SampleNextArrow(props) {
  const { style } = props;
  return <div style={{ ...style, display: 'none' }} />;
}

function SamplePrevArrow(props) {
  const { style } = props;
  return <div style={{ ...style, display: 'none' }} />;
}

const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

const businessesType = [
  {
    id: 1,
    name: 'businesses',
    colors: '#6525EE',
    buttonText: "Let's sell without borders",
  },
  {
    id: 2,
    name: 'Creators',
    colors: '#EA25EE',
    buttonText: 'Get paid in seconds',
  },
  {
    id: 3,
    name: 'Startups',
    colors: '#0EA101',
    buttonText: 'Start accepting payments',
  },
];

// ----------------------------------------------------------------------

export default function HomeHero() {
  return (
    <MotionContainer>
      <RootStyle>
        <HeroOverlayStyle alt="overlay" src={backgroundPic} variants={varFade().in} />

        <Container>
          <ContentStyle>
            <m.div variants={varFade().inRight}>
              <Typography variant="h1" sx={{ color: '#222326', fontFamily: 'Open Sans, sans-serif' }}>
                The payment processing system for
                <Typography component="span" variant="h1">
                  &nbsp;
                  <TextAnimation />
                </Typography>
              </Typography>
            </m.div>

            <m.div variants={varFade().inRight} style={{ paddingBottom: 10 }}>
              <Typography
                sx={{ color: 'common.black' }}
                style={{
                  fontSize: '0.8rem',
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  lineHeight: '198%',
                }}
              >
                Accepting payments shouldn't be a problem anymore, Swahilies has got your back. We've assmebled all the tools 
                you  need to make and accept local <br /> and international payments, so you can focus on selling to the world 🚀.
              </Typography>
            </m.div>

            <m.div variants={varFade().inRight}>
              <Button
                size="small"
                variant="contained"
                component={RouterLink}
                style={{ backgroundColor: '#6525EE' }}
                to="/"
                onClick={() => {
                  window.open('https://swahiles-dashboard.vercel.app/');
                }}
                endIcon={<Iconify icon={'akar-icons:arrow-up-right'} width={13} height={13} />}
              >
                Let's sell without borders
              </Button>
            </m.div>
          </ContentStyle>
        </Container>
      </RootStyle>
      <Box sx={{ height: { md: '100vh' } }} />
    </MotionContainer>
  );
}
